import type { ResponseReadAll } from "epsm-api-types";
import type { Pead } from "epsm-api-types/models";
import type { IReadAllParams } from "@/services/RequestParams";
import { useGetData } from "../../../../../hooks/useGetData";
import { PeadService } from "./PeadService";

export interface Options {
	params: IReadAllParams;
	signal?: AbortSignal;
}

export class UseData {
	private constructor(private service: PeadService) {}

	private static instance: UseData;

	static create() {
		if (!UseData.instance) {
			UseData.instance = new UseData(PeadService.create());
		}

		return UseData.instance;
	}

	getData = async ({
		params,
		signal,
	}: Readonly<Options>): Promise<ResponseReadAll<Pead>> => {
		return await this.service.getData(params, signal);
	};

	useGetData = () =>
		useGetData<ResponseReadAll<Pead>, Readonly<Options>>(this.getData);
}
